import { useCallback } from "react"

import { QueryClient, useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { axiosClient } from "$/http"

import { minutes, seconds } from "@/3514/utils"
import Urls from "@/api/urls"

import { QueryKey } from "../constants"
import { CalendarAccount } from "../models"

import { CalendarAccountApi } from "./types"

const getCalendarProfiles = async (): Promise<CalendarAccountApi[]> => {
    const { data } = await axiosClient.get(Urls.coachCalendarProfiles())
    return data
}

export function useCalendarProfiles(enabled: boolean, throwOnError = false) {
    return useQuery<CalendarAccountApi[], AxiosError, CalendarAccount[]>({
        queryKey: [QueryKey.Calendars],
        queryFn: getCalendarProfiles,
        select: useCallback(data => data.map(calendar => new CalendarAccount(calendar)), []),
        staleTime: minutes(15),
        gcTime: minutes(15),
        throwOnError,
        networkMode: "online",
        refetchOnWindowFocus: "always",
        refetchOnMount: true,
        retry: 1,
        retryDelay: seconds(3),
        experimental_prefetchInRender: true,
        enabled
    })
}

export async function calendarProfilesQueryPrefetcher({ qc }: { qc: QueryClient }): Promise<void> {
    await qc.prefetchQuery({
        queryKey: [QueryKey.Calendars],
        queryFn: getCalendarProfiles,
        gcTime: minutes(15),
        staleTime: minutes(15)
    })
}
